import { Component } from "@angular/core";
import { Ng1StateProxy } from "@gtmhub/core/routing";
import { IReflection, ReflectionScheduleCadence } from "@webapp/reflections/models/reflections.models";
import { ReflectionsFacade } from "@webapp/reflections/services/reflections-facade.service";
import { take } from "rxjs";
@Component({
  selector: "manage-reflection-schedule",
  templateUrl: "./manage-schedule.component.html",
  styleUrls: ["./manage-schedule.component.less"],
})
export class ManageReflectionScheduleComponent {
  public isPaused: boolean;
  public days: ReflectionScheduleCadence[] = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  public selectedDay: ReflectionScheduleCadence = "friday";
  public teamReflection: IReflection;

  constructor(private reflectionsFacade: ReflectionsFacade, private ng1StateProxy: Ng1StateProxy) {}

  public ngOnInit(): void {
    this.reflectionsFacade
      .getTeamReflection$({ teamId: this.ng1StateProxy.getParam("teamId") })
      .pipe(take(1))
      .subscribe((data) => {
        this.teamReflection = data;
        this.selectedDay = this.teamReflection.schedule.cadence;
        this.isPaused = !this.teamReflection.schedule.isPaused;
      });
  }

  public onScheduleToggle(): void {
    this.reflectionsFacade
      .patchReflection$({ reflectionId: this.teamReflection.id, payload: { schedule: { isPaused: !this.teamReflection.schedule.isPaused, cadence: this.selectedDay } } })
      .pipe(take(1))
      .subscribe(() => {
        this.teamReflection.schedule.isPaused = !this.teamReflection.schedule.isPaused;
        this.isPaused = this.teamReflection.schedule.isPaused;
      });
  }

  public selectDay(day: ReflectionScheduleCadence): void {
    this.reflectionsFacade
      .patchReflection$({ reflectionId: this.teamReflection.id, payload: { schedule: { isPaused: this.isPaused, cadence: day } } })
      .pipe(take(1))
      .subscribe(() => {
        this.selectedDay = day;
      });
  }
}
